import { getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js/min';

// Include European states and territories; shared calling codes have one option.
export const EUROPEAN_PHONE_REGIONS = 'DE AL AD AM AT AZ AX BY BE BA BG HR CY CZ DK EE FO FI FR GE GI GR GG HU IS IE IM IT JE XK KZ LV LI LT LU MT MD MC ME NL MK NO PL PT RO RU SM RS SK SI ES SJ SE CH TR UA GB VA'.split(' ');
const names = new Intl.DisplayNames(['de'], { type: 'region' });
const byCallingCode = new Map();
for (const region of EUROPEAN_PHONE_REGIONS) {
  const code = `+${getCountryCallingCode(region)}`;
  if (!byCallingCode.has(code)) byCallingCode.set(code, []);
  byCallingCode.get(code).push(names.of(region));
}
export const COUNTRY_PHONE_CODES = [...byCallingCode].map(([code, countries]) => ({
  code, label: `${countries.join(' / ')} (${code})`,
})).sort((a, b) => a.code === '+49' ? -1 : b.code === '+49' ? 1 : a.label.localeCompare(b.label, 'de'));

export function phoneInputText(value) {
  return String(value ?? '').normalize('NFKC').replace(/[\u2010-\u2015\u2212]/g, '-');
}

export function sanitizePhoneInput(value) {
  return phoneInputText(value).replace(/[^0-9+()\s./-]/g, '');
}

export function isPhoneInput({ inputKind, type, name, id, autoComplete, 'data-testid': testId }) {
  if (inputKind) return inputKind === 'phone';
  if (type === 'search') return false;
  if (type === 'tel' || autoComplete?.startsWith('tel')) return true;
  const key = [name, id, testId, autoComplete].filter(Boolean).join(' ');
  return /phone|telefon/i.test(key) && !/search|query|filter/i.test(key);
}

// Explicit international input takes precedence over the selected default code.
// Metadata handles country-specific trunk prefixes (including Italy's significant 0).
export function buildFullPhone(countryCode, localNumber) {
  const raw = phoneInputText(localNumber).trim();
  if (!raw || !/^[0-9+()\s./-]+$/.test(raw)) return '';
  const value = raw.replace(/^00/, '+');
  const code = String(countryCode || '').trim();
  if (!value.startsWith('+') && !/^\+[1-9][0-9]{0,2}$/.test(code)) return '';
  const parsed = parsePhoneNumberFromString(value, { defaultCallingCode: code.slice(1), extract: false });
  return parsed && !parsed.ext && parsed.isPossible() ? parsed.number : '';
}

export function isValidPhone(countryCode, localNumber) {
  return Boolean(buildFullPhone(countryCode, localNumber));
}
